import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { UpdatePermissionValidationSchema } from "../schemas/create.schema";

interface UseUpdatePermissionProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdatePermission = ({id, onSuccess, onError}: UseUpdatePermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updatePermission'],
    mutationFn: async (form: UpdatePermissionValidationSchema) => privateAxios.put(`/permissions/${id}`, form),
    onSuccess,
    onError
  });
}

export default useUpdatePermission
